"use client";

import { CATEGORIES } from "@/constants/categories";
import CategoryPage from "../CategoryPage";
import SchemaScript from "@/components/common/SchemaScript";
import { Routes } from "@/constants/routes";
import { Locale } from "@/constants/locales";
import { useLocale } from "next-intl";

export default function PersonalCategory() {
    const locale = useLocale() as Locale;
    
    return (
        <>
            <CategoryPage
                category={CATEGORIES.personal}
            />

            <SchemaScript route={Routes.personal} locale={locale} />
        </>
    )
} 